import { useState, useEffect, useRef } from "react";
import { FaTimes, FaBars } from "react-icons/fa";
import brandLogo from "../assets/brandLogo.png"

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  const linksRef = useRef<(HTMLAnchorElement | null)[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getBrandLogo = () => {
    return brandLogo;
  };



  return (
    <div
      ref={navRef}
      className={`fixed top-0 left-0 w-full z-[1000]  `}
    >
      <nav
        className={`w-full flex items-center justify-between   relative border-white/10 ${scrolled
          ? 'bg-white/40 backdrop-blur-xl px-8 md:px-14 py-8 rounded-none border-b border-white/20'
          : 'bg-white/40 backdrop-blur-xl px-8 md:px-14 py-8 rounded-none border-b border-white/20'
          }`}
      >
        {/* Logo with Enhanced Visibility Overlay */}
        <a href="/" className="flex items-center group relative z-10">
          <div className="relative">
            <div className="absolute inset-0 bg-white/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
            <img
              className="h-10 md:h-16 object-contain transition-all duration-700 group-hover:scale-105 relative z-10"
              src={getBrandLogo()}
              alt={import.meta.env.VITE_COMPANY_NAME}
            />
          </div>
        </a>

        {/* Desktop Menu - High Contrast & Geometric */}
        <div className="hidden lg:flex items-center gap-10 relative z-10 ">
          {[
            { label: "Home", href: "/" },
            { label: "Our Story", href: "/about" },
            { label: "Solutions", href: "/#services" },
            { label: "Loan Calculator", href: "/loan-calculator" },
            { label: "Contact Us", href: "/contact" },
            { label: "Repay", href: "/repay" },
          ].map((item, i) => (
            <a
              key={item.label}
              ref={(el) => { linksRef.current[i] = el; }}
              href={item.href}
              className="relative text-text-primary font-black text-[10px] uppercase tracking-[0.3em] transition-all hover:text-secondary group"
            >
              {item.label}
              <span className="absolute left-0 -bottom-2 w-0 h-[3px] bg-secondary transition-all duration-500 ease-out group-hover:w-full opacity-0 group-hover:opacity-100 rounded-full" />
            </a>
          ))}

          <div className="h-8 w-[1px] bg-gray-200 mx-2" />


          <a
            href={import.meta.env.VITE_WEBSITE_LINK}
            target="_blank"
            className="relative px-10 py-4 bg-secondary text-white font-black text-[10px] uppercase tracking-[0.3em] transition-all hover:bg-primary hover:shadow-[0_20px_40px_rgba(31,41,55,0.3)] shadow-xl hover:-translate-y-1 rounded-2xl overflow-hidden group/btn"
          >
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover/btn:translate-y-0 transition-transform duration-500" />
            <span className="relative z-10">Instant Apply</span>
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden w-11 h-11 bg-primary rounded-xl flex items-center justify-center text-white transition-all hover:bg-secondary active:scale-90"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <FaTimes size={16} /> : <FaBars size={16} />}
        </button>

      </nav>

      {/* Mobile Dropdown - outside nav, relative to fixed wrapper */}
      <div
        className={`w-full transition-all duration-300 origin-top overflow-hidden z-[999] ${menuOpen ? 'max-h-[600px] opacity-100' : 'max-h-0 opacity-0 pointer-events-none'}`}
      >
        <div className="bg-white shadow-xl border-t border-gray-100 px-6 py-4 flex flex-col gap-2">
          {[
            { label: "Home", href: "/" },
            { label: "About Us", href: "/about" },
            { label: "Services", href: "/#services" },
            { label: "Loan Calculator", href: "/loan-calculator" },
            { label: "Contact Us", href: "/contact" },
            { label: "Repay Now", href: "/repay" },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="flex items-center justify-between px-5 py-4 rounded-2xl hover:bg-blue-50 text-text-primary hover:text-primary transition-all duration-200"
              onClick={() => setMenuOpen(false)}
            >
              <span className="font-semibold text-sm">{item.label}</span>
              <span className="text-primary text-xs">›</span>
            </a>
          ))}
          <div className="flex flex-col gap-3 pt-4 border-t border-gray-100 mt-2">
            <a href={import.meta.env.VITE_WEBSITE_LINK} target="_blank" className="w-full h-12 flex items-center justify-center border-2 border-primary text-primary font-bold text-sm rounded-2xl hover:bg-primary hover:text-white transition-all">
              Sign In
            </a>
            <a href={import.meta.env.VITE_WEBSITE_LINK} target="_blank" className="w-full h-12 flex items-center justify-center bg-primary text-white font-bold text-sm rounded-2xl hover:bg-secondary transition-all shadow-md">
              Apply Loan
            </a>
          </div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{
        __html: `
        @keyframes slow-slide {
          from { transform: translateX(-20%); }
          to { transform: translateX(20%); }
        }
        .animate-slow-slide {
          animation: slow-slide 10s linear infinite alternate;
        }
      `}} />
    </div>
  );
};

export default Navbar;
